var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfettiLeft = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "267px",
  height: "320px",
  viewBox: "0 0 267 320",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "confetti")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.388235 0 0 0 0 0.788235 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.4928844,4.91455682 L2.94753975,4.91455682 C2.40408711,4.91455682 1.9650265,5.35379534 1.9650265,5.89746819 L1.9650265,25.5556955 C1.9650265,26.0993684 2.40408711,26.5386069 2.94753975,26.5386069 L28.4928844,26.5386069 C29.036337,26.5386069 29.4753976,26.0993684 29.4753976,25.5556955 L29.4753976,5.89746819 C29.4753976,5.35379534 29.036337,4.91455682 28.4928844,4.91455682 Z M4.17568132,7.1261074 L27.2647428,7.1261074 L27.2647428,10.812025 L4.17568132,10.812025 L4.17568132,7.1261074 Z M27.2647428,24.3270563 L4.17568132,24.3270563 L4.17568132,13.5150313 L27.2647428,13.5150313 L27.2647428,24.3270563 Z M19.988004,22.3612336 L25.054088,22.3612336 C25.1891835,22.3612336 25.2997163,22.250656 25.2997163,22.1155057 L25.2997163,19.9039552 C25.2997163,19.7688048 25.1891835,19.6582273 25.054088,19.6582273 L19.988004,19.6582273 C19.8529084,19.6582273 19.7423757,19.7688048 19.7423757,19.9039552 L19.7423757,22.1155057 C19.7423757,22.250656 19.8529084,22.3612336 19.988004,22.3612336 Z",
  id: "path-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.8440494,10.0629045 C10.5564006,10.0629045 11.132725,9.48634661 11.132725,8.77370675 L11.132725,1.28919772 C11.132725,0.576557862 10.5564006,-1.04772888e-08 9.8440494,-1.04772888e-08 C9.13169819,-1.04772888e-08 8.55537384,0.576557862 8.55537384,1.28919772 L8.55537384,8.77370675 C8.55537384,9.48634661 9.13169819,10.0629045 9.8440494,10.0629045 Z M31.7873305,15.2196954 L27.4917453,15.2196954 C27.4917453,13.7944157 26.3390966,12.6412999 24.9143941,12.6412999 L7.15930865,12.6412999 C5.73460623,12.6412999 4.58195753,13.7944157 4.58195753,15.2196954 L4.58195753,24.1008353 C4.58195753,24.2225929 4.58911684,24.3407693 4.60701511,24.4553647 C4.58911684,24.706042 4.58195753,24.9567193 4.58195753,25.2109778 C4.58195753,31.53879 9.71160219,36.6705131 16.0368514,36.6705131 C21.767878,36.6705131 26.5144996,32.462715 27.359298,26.9657191 L31.7873305,26.9657191 C33.2120329,26.9657191 34.3646816,25.8126034 34.3646816,24.3873237 L34.3646816,17.7980908 C34.3646816,16.3728111 33.2120329,15.2196954 31.7873305,15.2196954 Z M24.9143941,24.3873237 L24.8750179,24.3873237 C24.9000755,24.6594876 24.9143941,24.9316516 24.9143941,25.2109778 C24.9143941,30.1170914 20.9409778,34.0921177 16.0368514,34.0921177 C11.132725,34.0921177 7.15930865,30.1170914 7.15930865,25.2109778 C7.15930865,24.9316516 7.17362727,24.6594876 7.19868485,24.3873237 L7.15930865,24.3873237 L7.15930865,15.2196954 L24.9143941,15.2196954 L24.9143941,24.3873237 Z M31.7873305,24.1008353 L27.7781176,24.1008353 L27.7781176,17.7980908 L31.7873305,17.7980908 L31.7873305,24.1008353 Z M21.943281,10.0629045 C22.6556323,10.0629045 23.2319566,9.48634661 23.2319566,8.77370675 L23.2319566,1.28919772 C23.2319566,0.576557862 22.6556323,-1.04772888e-08 21.943281,-1.04772888e-08 C21.2309298,-1.04772888e-08 20.6546055,0.576557862 20.6546055,1.28919772 L20.6546055,8.77370675 C20.6546055,9.48634661 21.2309298,10.0629045 21.943281,10.0629045 Z M15.8578687,10.0629045 C16.5702199,10.0629045 17.1465442,9.48634661 17.1465442,8.77370675 L17.1465442,1.28919772 C17.1465442,0.576557862 16.5702199,-1.04772888e-08 15.8578687,-1.04772888e-08 C15.1455175,-1.04772888e-08 14.5691931,0.576557862 14.5691931,1.28919772 L14.5691931,8.77370675 C14.5691931,9.48634661 15.1455175,10.0629045 15.8578687,10.0629045 Z",
  id: "path-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.5453446,1.96582272 L5.89507952,1.96582272 C5.35162687,1.96582272 4.91256626,2.40506124 4.91256626,2.94873409 L4.91256626,28.5044296 C4.91256626,29.0481025 5.35162687,29.487341 5.89507952,29.487341 L25.5453446,29.487341 C26.0887972,29.487341 26.5278579,29.0481025 26.5278579,28.5044296 L26.5278579,2.94873409 C26.5278579,2.40506124 26.0887972,1.96582272 25.5453446,1.96582272 Z M17.5624244,4.1773733 L20.5099642,4.1773733 L20.5099642,10.6246575 L19.0822496,9.58338581 L17.5624244,10.6707315 L17.5624244,4.1773733 Z M24.317203,27.2757904 L7.12322108,27.2757904 L7.12322108,4.1773733 L15.7202121,4.1773733 L15.7202121,13.2969478 C15.7202121,13.3983106 15.7509156,13.4996733 15.8123227,13.5826064 C15.8876139,13.689083 16.0023489,13.7610086 16.1309626,13.7823567 C16.2595763,13.8037049 16.3913823,13.7727018 16.4970116,13.6962556 L19.0699682,11.8563683 L21.5692363,13.6808976 C21.6521358,13.7423295 21.7534575,13.7761171 21.8578495,13.7761171 C22.1280407,13.7761171 22.3491062,13.5549621 22.3491062,13.2846614 L22.3491062,4.1773733 L24.3141327,4.1773733 L24.3141327,27.2757904 L24.317203,27.2757904 Z",
  id: "path-6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.4453808,6.03721862 L6.70530371,6.03721862 C6.33651201,6.03721862 6.03477334,6.33907955 6.03477334,6.70802069 L6.03477334,19.45326 C6.03477334,19.8222012 6.33651201,20.1240621 6.70530371,20.1240621 L19.4453808,20.1240621 C19.8141725,20.1240621 20.1159112,19.8222012 20.1159112,19.45326 L20.1159112,6.70802069 C20.1159112,6.33907955 19.8141725,6.03721862 19.4453808,6.03721862 Z M17.2661571,17.2731533 L8.88452742,17.2731533 L8.88452742,8.88812741 L17.2661571,8.88812741 L17.2661571,17.2731533 Z M36.2086401,6.03721862 L23.468563,6.03721862 C23.0997713,6.03721862 22.7980327,6.33907955 22.7980327,6.70802069 L22.7980327,19.45326 C22.7980327,19.8222012 23.0997713,20.1240621 23.468563,20.1240621 L36.2086401,20.1240621 C36.5774318,20.1240621 36.8791705,19.8222012 36.8791705,19.45326 L36.8791705,6.70802069 C36.8791705,6.33907955 36.5774318,6.03721862 36.2086401,6.03721862 Z M34.0294164,17.2731533 L25.6477867,17.2731533 L25.6477867,8.88812741 L34.0294164,8.88812741 L34.0294164,17.2731533 Z M19.4453808,22.8072704 L6.70530371,22.8072704 C6.33651201,22.8072704 6.03477334,23.1091313 6.03477334,23.4780724 L6.03477334,36.2233118 C6.03477334,36.5922529 6.33651201,36.8941138 6.70530371,36.8941138 L19.4453808,36.8941138 C19.8141725,36.8941138 20.1159112,36.5922529 20.1159112,36.2233118 L20.1159112,23.4780724 C20.1159112,23.1091313 19.8141725,22.8072704 19.4453808,22.8072704 Z M17.2661571,34.043205 L8.88452742,34.043205 L8.88452742,25.6581792 L17.2661571,25.6581792 L17.2661571,34.043205 Z M36.2086401,22.8072704 L23.468563,22.8072704 C23.0997713,22.8072704 22.7980327,23.1091313 22.7980327,23.4780724 L22.7980327,36.2233118 C22.7980327,36.5922529 23.0997713,36.8941138 23.468563,36.8941138 L36.2086401,36.8941138 C36.5774318,36.8941138 36.8791705,36.5922529 36.8791705,36.2233118 L36.8791705,23.4780724 C36.8791705,23.1091313 36.5774318,22.8072704 36.2086401,22.8072704 Z M34.0294164,34.043205 L25.6477867,34.043205 L25.6477867,25.6581792 L34.0294164,25.6581792 L34.0294164,34.043205 Z",
  id: "path-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0358374,8.47964855 C9.88665602,8.47964855 9.76459854,8.60175549 9.76459854,8.75099731 L9.76459854,10.3790898 C9.76459854,10.5283316 9.88665602,10.6504386 10.0358374,10.6504386 L23.0553021,10.6504386 C23.2044835,10.6504386 23.326541,10.5283316 23.326541,10.3790898 L23.326541,8.75099731 C23.326541,8.60175549 23.2044835,8.47964855 23.0553021,8.47964855 L10.0358374,8.47964855 Z M16.2743309,13.3639261 L10.0358374,13.3639261 C9.88665602,13.3639261 9.76459854,13.4860331 9.76459854,13.6352749 L9.76459854,15.2633674 C9.76459854,15.4126092 9.88665602,15.5347162 10.0358374,15.5347162 L16.2743309,15.5347162 C16.4235123,15.5347162 16.5455698,15.4126092 16.5455698,15.2633674 L16.5455698,13.6352749 C16.5455698,13.4860331 16.4235123,13.3639261 16.2743309,13.3639261 Z M14.6468978,28.8986423 L7.05221005,28.8986423 L7.05221005,5.01995194 L26.0389295,5.01995194 L26.0389295,15.8739021 C26.0389295,16.0231439 26.1609869,16.1452509 26.3101683,16.1452509 L28.2088402,16.1452509 C28.3580216,16.1452509 28.4800791,16.0231439 28.4800791,15.8739021 L28.4800791,3.66320817 C28.4800791,3.06284905 27.9952396,2.57781315 27.3951237,2.57781315 L5.69601581,2.57781315 C5.09589986,2.57781315 4.61106042,3.06284905 4.61106042,3.66320817 L4.61106042,30.2553861 C4.61106042,30.8557452 5.09589986,31.3407811 5.69601581,31.3407811 L14.6468978,31.3407811 C14.7960792,31.3407811 14.9181367,31.2186741 14.9181367,31.0694323 L14.9181367,29.169991 C14.9181367,29.0207492 14.7960792,28.8986423 14.6468978,28.8986423 Z M29.5650345,25.913806 L24.6827352,25.913806 L24.6827352,24.6723854 C26.25253,24.2043088 27.3951237,22.752593 27.3951237,21.0295284 C27.3951237,18.9299674 25.6964904,17.2306459 23.5977798,17.2306459 C21.4990692,17.2306459 19.8004359,18.9299674 19.8004359,21.0295284 C19.8004359,22.7492012 20.9430296,24.2043088 22.5128244,24.6723854 L22.5128244,25.913806 L17.6305251,25.913806 C17.3321624,25.913806 17.0880475,26.1580199 17.0880475,26.4565035 L17.0880475,31.6121298 C17.0880475,31.9106135 17.3321624,32.1548273 17.6305251,32.1548273 L29.5650345,32.1548273 C29.8633972,32.1548273 30.1075122,31.9106135 30.1075122,31.6121298 L30.1075122,26.4565035 C30.1075122,26.1580199 29.8633972,25.913806 29.5650345,25.913806 Z M21.902537,21.0295284 C21.902537,20.0933752 22.6620058,19.3335987 23.5977798,19.3335987 C24.5335538,19.3335987 25.2930226,20.0933752 25.2930226,21.0295284 C25.2930226,21.9656816 24.5335538,22.7254581 23.5977798,22.7254581 C22.6620058,22.7254581 21.902537,21.9656816 21.902537,21.0295284 Z M28.0054111,30.0518745 L19.1901485,30.0518745 L19.1901485,28.0167588 L28.0054111,28.0167588 L28.0054111,30.0518745 Z",
  id: "path-10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9943638,33.0055581 L37.0095223,24.8280616 C36.9766942,24.5571205 36.6443102,24.4421757 36.4514454,24.6351187 L34.0180663,27.073589 L22.885254,15.9403709 C22.6267331,15.6858504 22.212279,15.6858504 21.9578616,15.9403709 L17.7804923,20.1153277 L6.42609067,8.75632529 C6.29767631,8.62911962 6.09080884,8.62911962 5.96239448,8.75632529 L4.11581669,10.6118616 C3.98866254,10.740328 3.98866254,10.9472793 4.11581669,11.0757457 L17.3167961,24.2902845 C17.5712135,24.5489101 17.9897711,24.5489101 18.2441885,24.2902845 L22.4215578,20.1153277 L31.6995853,29.3930094 L29.2662061,31.8273746 C29.1776779,31.9163773 29.1475414,32.0480458 29.1885365,32.1667181 C29.2295316,32.2853903 29.3345016,32.3703487 29.4590709,32.3856776 L37.6332552,33.3709181 C37.842534,33.3996543 38.0230883,33.2190269 37.9943638,33.0055581 Z",
  id: "path-12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.2611504,5.53877541 L3.17337811,5.53877541 C2.57583776,5.53877541 2.09307917,6.02172961 2.09307917,6.61951208 L2.09307917,28.2342454 C2.09307917,28.8320279 2.57583776,29.3149821 3.17337811,29.3149821 L31.2611504,29.3149821 C31.8586907,29.3149821 32.3414493,28.8320279 32.3414493,28.2342454 L32.3414493,6.61951208 C32.3414493,6.02172961 31.8586907,5.53877541 31.2611504,5.53877541 Z M29.9107767,26.8833246 L4.52375177,26.8833246 L4.52375177,7.97043292 L29.9107767,7.97043292 L29.9107767,26.8833246 Z M7.66674648,24.103805 C7.77140044,24.2085014 7.94357308,24.2085014 8.04822704,24.103805 L13.8717135,18.2779589 L17.7337822,22.1449698 C17.8384361,22.2496661 18.0106088,22.2496661 18.1152627,22.1449698 L28.1417872,12.107628 C28.2464412,12.0029316 28.2464412,11.8306892 28.1417872,11.7259928 L26.8994434,10.4831457 C26.7937976,10.3784942 26.6236087,10.3784942 26.5179629,10.4831457 L17.9262104,19.0817568 L14.0641417,15.2147459 C13.9584959,15.1100944 13.788307,15.1100944 13.6826612,15.2147459 L6.42777864,22.4759454 C6.32316956,22.5816341 6.32316956,22.7518919 6.42777864,22.8575805 L7.66674648,24.103805 L7.66674648,24.103805 Z",
  id: "path-14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.1900643,12.0491075 L28.4554581,12.0491075 C28.98385,11.2173304 29.2946687,10.2300809 29.2946687,9.17286892 C29.2946687,6.21500737 26.8897085,3.80907268 23.933045,3.80907268 C22.3245579,3.80907268 20.8753654,4.52424551 19.892401,5.65142008 C18.9094367,4.52424551 17.4602442,3.80907268 15.8517571,3.80907268 C12.8950936,3.80907268 10.4901334,6.21500737 10.4901334,9.17286892 C10.4901334,10.2300809 10.7970669,11.2173304 11.329344,12.0491075 L5.59473778,12.0491075 C4.90705126,12.0491075 4.35146272,12.6049211 4.35146272,13.2928863 L4.35146272,21.0665041 C4.35146272,21.2375236 4.49133116,21.3774488 4.66228148,21.3774488 L6.21637532,21.3774488 L6.21637532,34.7480713 C6.21637532,35.4360364 6.77196386,35.9918501 7.45965038,35.9918501 L32.3251517,35.9918501 C33.0128382,35.9918501 33.5684268,35.4360364 33.5684268,34.7480713 L33.5684268,21.3774488 L35.1225206,21.3774488 C35.2934709,21.3774488 35.4333394,21.2375236 35.4333394,21.0665041 L35.4333394,13.2928863 C35.4333394,12.6049211 34.8777508,12.0491075 34.1900643,12.0491075 Z M21.2133808,9.17286892 C21.2133808,7.6725607 22.4333445,6.45210271 23.933045,6.45210271 C25.4327455,6.45210271 26.6527092,7.6725607 26.6527092,9.17286892 C26.6527092,10.6731771 25.4327455,11.8936351 23.933045,11.8936351 L21.2133808,11.8936351 L21.2133808,9.17286892 Z M15.8517571,6.45210271 C17.3514576,6.45210271 18.5714213,7.6725607 18.5714213,9.17286892 L18.5714213,11.8936351 L15.8517571,11.8936351 C14.3520565,11.8936351 13.1320929,10.6731771 13.1320929,9.17286892 C13.1320929,7.6725607 14.3520565,6.45210271 15.8517571,6.45210271 Z M6.99342223,18.7344187 L6.99342223,14.6921375 L18.5714213,14.6921375 L18.5714213,18.7344187 L6.99342223,18.7344187 Z M8.85833483,21.3774488 L18.5714213,21.3774488 L18.5714213,33.3488201 L8.85833483,33.3488201 L8.85833483,21.3774488 Z M30.9264672,33.3488201 L21.2133808,33.3488201 L21.2133808,21.3774488 L30.9264672,21.3774488 L30.9264672,33.3488201 Z M32.7913798,18.7344187 L21.2133808,18.7344187 L21.2133808,14.6921375 L32.7913798,14.6921375 L32.7913798,18.7344187 Z",
  id: "path-16"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Summer-2020-Refresh",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.15
}, /*#__PURE__*/React.createElement("g", {
  id: "confetti",
  transform: "translate(-280.000000, -152.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(280.000000, 152.332226)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(49.361571, 246.765873)",
  opacity: 0.96
}, /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/dollar-copy-2",
  transform: "translate(15.720212, 15.726582) rotate(-26.000000) translate(-15.720212, -15.726582) "
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/credit-card",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-3)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 31.4404241,
  height: 31.4531637
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(7.639681, 148.977838)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/dollar-copy-3",
  transform: "translate(18.327830, 18.335257) rotate(-45.000000) translate(-18.327830, -18.335257) "
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-5",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-4"
})), /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/coffee",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-5)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 36.6556603,
  height: 36.6705131
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(167.225910, 94.866471)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/dollar-copy-7",
  transform: "translate(15.720212, 15.726582) rotate(-36.000000) translate(-15.720212, -15.726582) "
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-7",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-6"
})), /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/book",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-7)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 31.4404241,
  height: 31.4531637
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(220.896471, 229.805622)",
  opacity: 0.9
}, /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/dollar-copy-9",
  transform: "translate(21.456972, 21.465666) rotate(-81.000000) translate(-21.456972, -21.465666) "
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-9",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-8"
})), /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/appstore",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-9)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 42.9139438,
  height: 42.9313325
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(108.666257, 168.058431)",
  opacity: 0.78
}, /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/dollar-copy-11",
  transform: "translate(17.359286, 17.366320) rotate(-153.000000) translate(-17.359286, -17.366320) "
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-11",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-10"
})), /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/audit",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-11)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 34.7185726,
  height: 34.7326405
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(99.048956, 8.519185)",
  opacity: 0.74
}, /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/dollar-copy-13",
  transform: "translate(21.009952, 21.018465) rotate(-128.000000) translate(-21.009952, -21.018465) "
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-13",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-12"
})), /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/fall",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-13)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 42.0199033,
  height: 42.0369297
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(133.172630, 276.794014)",
  opacity: 0.86
}, /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/dollar-copy-14",
  transform: "translate(17.284783, 17.291787) rotate(-48.000000) translate(-17.284783, -17.291787) "
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-15",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-14"
})), /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/fund",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-15)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 34.5695658,
  height: 34.5835734
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(43.103287, 68.779724)",
  opacity: 0.89
}, /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/dollar-copy-15",
  transform: "translate(19.892401, 19.900461) rotate(-33.000000) translate(-19.892401, -19.900461) "
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-17",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-16"
})), /*#__PURE__*/React.createElement("g", {
  id: "antd/outline/gift",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-17)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 39.7848021,
  height: 39.8009228
}))))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfettiLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confetti-left.f0920aa831aa2df78de27d02315f995f.svg";